import React, { useEffect,useState } from 'react';
import {  Link,useNavigate } from 'react-router-dom';

import Input from '../input';
import Button from '../button';
import MessageDialog from '../messageDialog';
import LoadingOverlay from '../loadingOverlay';
import config from '../../config';
import {get, post } from '../../request'
import './styles.scss';
import ForgetPasswordDialog from '../forgetPasswordDialog';

function LoginDialog({ message, onConfirm, onCancel, nextLink, isShowLogin}) {
    const [isLoading, setIsLoading] = useState(false);
    const [showForgetPws, setShowForgetPws ]= useState(false);
    
    const [isDisable, setBtnDisable] = useState(true);
    const [item, setInputs] = useState({
        loginName: '',
        password: ''
    });
    const [isValid, setIsValid] = useState({
        loginName: false,
        password: false
    });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        var allValid = isValid["loginName"] && isValid["password"];
        setBtnDisable(!allValid);

    }, [isValid, item, successMessage, errorMessage.isLoading]);

    

    const handleInputChange = (name, value) => {
        setInputs({ ...item, [name]: value });
    };
    const showDialog = () => {
        //setIsVisible(true);
    };

    const hideDialog = () => {
        //setIsVisible(false);
        if (onCancel) {
            onCancel(false);
        }
    };
    const navigate = useNavigate();
    const handleClick = () => {
        //onConfirm();
        setSuccessMessage("");
        setErrorMessage("");
        setIsLoading(true);
        post('delianapi/login', {
            loginName: item.loginName,
            password: item.password,
            isActive: 1
        }).then((response)=> {
            setIsLoading(false);
            if (response.statusCode !== 200) {
                setErrorMessage( response.message);
                return;
            }
            var loginItem = response.items[0];
            localStorage.setItem('Authorization', loginItem.userHash);
            get('delianapi/user/userinfo', {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    Authorization: localStorage.getItem('Authorization')
                }
            })
                .then((response) => {
                    var loginItem = response.items[0];
                    const loginItemString = JSON.stringify(loginItem.user);
                    localStorage.setItem('user', loginItemString);
                    if (nextLink) {
                        navigate(config.root + nextLink);
                    }
                    else {
                        //navigate.push(navigate.location.pathname);
                    }
                    hideDialog();
            });
        });
       
    };

    const handleCancel = () => {
        //onCancel();
        hideDialog();
    };
    const handleValidInput = (name, isNewValid) => {
        setIsValid({ ...isValid, [name]: isNewValid });
        
    }
    return (
        <div className="dialog" style={{ display: isShowLogin ? 'flex' : 'none' }}>
            <div className="dialogModel">
                <div className="closeDialog" onClick={() => handleCancel()}></div>
                    
                    <div className="dialogTitle">登录</div>
                    <div className="dialog-content">
                        <Input className="input" placeholder="用户名" value={item.loginName}
                            name="loginName" onChange={value => handleInputChange('loginName', value)}                            
                            checkRequied={true} onValidInput={handleValidInput} />
                    <Input className="input" placeholder="密码"
                        value={item.password} inputType="password"
                        name="password" onChange={value => handleInputChange('password', value)}
                        checkRequied={true} onValidInput={handleValidInput}                    />

                    <Button btnclass="login_btn " onClick={() => handleClick()}
                        title="登&nbsp;&nbsp;录" disabled={isDisable } />
                        <div className="dialog-info">
                        <Link to="" onClick={() => { setShowForgetPws(true); }} className="" > 忘记密码 </Link>
                            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <Link to={`${config.root}/JoinUsStep`} className="" > 注册</Link>
                        </div>
                    </div>
            </div>

            <MessageDialog message={successMessage || errorMessage} onCancel={() => {setSuccessMessage("");
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading} />
            <ForgetPasswordDialog isShow={showForgetPws} onCancel={() => { setShowForgetPws(false); }}/>
        </div>
    );
};

export default LoginDialog;